<template>
  <v-container>
    <v-card outlined>
      <v-card-title class="d-print-none">
        Modifica {{ model.verboseName.toLowerCase() }}
      </v-card-title>
      <v-card-text>
        <slot
          name="form"
          v-bind="{ error, fetch, item, loading, submit }"
        ></slot>
      </v-card-text>
      <v-btn
        fab
        large
        fixed
        bottom
        right
        color="primary"
        class="mr-2 mb-2 d-print-none"
        @click="print"
      >
        <v-icon>fa fa-print</v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import isEmpty from "lodash/isEmpty"
import { mapState } from "vuex"

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: {},
    }
  },
  computed: mapState({
    loading(state) {
      return state[this.model.appName].pending[this.model.propName]
    },
    item(state) {
      if (!isEmpty(this.localData)) {
        return this.localData
      }
      return state[this.model.appName][this.model.propName]
    },
    error(state) {
      if (state[this.model.appName].error[this.model.propName]) {
        return state[this.model.appName].error[this.model.propName].response
          .data
      }
      return {}
    },
  }),
  created() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch(`retrieve${this.model.modelName}`, {
        params: { id: this.$route.params.id },
      })
    },
    print() {
      window.print()
    },
    async submit(event) {
      const item = event
      try {
        await this.$store.dispatch(`update${this.model.modelName}`, {
          params: { id: this.$route.params.id },
          data: item,
        })
        this.$store.commit("core/setSnack", {
          level: "success",
          msg: "Modificato con successo.",
        })
        this.localData = {}
      } catch (err) {
        // console.log(err)
        this.$store.commit("core/setSnack", {
          level: "error",
          msg: "Modifica non riuscita. Controlla gli errori e riprova.",
        })
        this.localData = item
      }
    },
  },
}
</script>

<style>
@media print {
  .v-input:not(.v-input--is-dirty),
  .v-messages {
    display: none;
  }
}
</style>
